import { Action } from "@ngrx/store";



//Variaveis dos Cards
export interface DeputyStateModel {
  currentSubstitute: any;
  currentImpersonalization: any;
  possibleDeputies: any;
  possibleImpersonalizationList: any;
  businessEntityUsers: any;
  isPhotosLoaded: boolean;
}

export enum DeputyActionTypes {

  LOAD_SUBSTITUTE_FAILURE = "[Deputy] LOAD_FAILURE Deputy",
  LOAD_SUBSTITUTE_SUCCESS = "[Deputy] LOAD_SUCCESS Deputy",
  LOAD_SUBSTITUTE = "[Deputy] LOAD Deputy",

  LOAD_SUBSTITUTES_PHOTOS = "[User] LOAD_SUBSTITUTES_PHOTOS",
  LOAD_SUBSTITUTES_PHOTOS_SUCCESS = "[User] LOAD_SUBSTITUTES_PHOTOS_SUCCESS",
  LOAD_SUBSTITUTES_PHOTOS_FAILURE = "[User] LOAD_SUBSTITUTES_PHOTOS_FAILURE",

  LOAD_POSSIBLE_DEPUTIES_FAILURE = "[Deputy] LOAD_POSSIBLE_DEPUTIES_FAILURE Deputy",
  LOAD_POSSIBLE_DEPUTIES_SUCCESS = "[Deputy] LOAD_POSSIBLE_DEPUTIES_SUCCESS Deputy",
  LOAD_POSSIBLE_DEPUTIES = "[Deputy] LOAD_POSSIBLE_DEPUTIES Deputy",

  LOAD_IMPERSONALIZATION_LIST = "[Deputy] LOAD IMPERSONALIZATION LIST",
  LOAD_IMPERSONALIZATION_LIST_FAILURE = "[Deputy] LOAD IMPERSONALIZATION LIST FAILURE",
  LOAD_IMPERSONALIZATION_LIST_SUCCESS = "[Deputy] LOAD IMPERSONALIZATION LIST SUCCESS",

  LOAD_USERS_LIST = "[Deputy] LOAD USERS LIST",
  LOAD_USERS_LIST_FAILURE = "[Deputy] LOAD USERS LIST FAILURE",
  LOAD_USERS_LIST_SUCCESS = "[Deputy] LOAD USERS LIST SUCCESS",

  IMPERSONALIZE_USER = "[Deputy] IMPERSONALIZE USER",
  IMPERSONALIZE_USER_FAILURE = "[Deputy] IMPERSONALIZE USER FAILURE",
  IMPERSONALIZE_USER_SUCCESS = "[Deputy] IMPERSONALIZE USER SUCCESS",

  DELETE_BUSINESS_ENTITY_USERS = "[Deputy] DELETE BUSINESS ENTITY USERS",

  DELETE_IMPERSONALIZATION_LIST = "[Deputy] DELETE IMPERSONALIZATION LIST",

  DELETE = "[Deputy] DELETE",

  DELETE_IMPERSONALIZATION = "[Deputy] DELETE ACTIVE IMPERSONALIZATION",
  DELETE_DEPUTY = "[Deputy] DELETE ACTIVE DEPUTY"

}

export class LoadSubstitutesPhotos implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS;

  constructor(public substitutes: any) { }
}

export class LoadSubstitutesPhotosSuccess implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS_SUCCESS;

  constructor(public photos: any) { }
}

export class LoadSubstitutesPhotosFailure implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTES_PHOTOS_FAILURE;

  constructor() { }
}

export class LoadSubstitute implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTE;

  constructor(public username: string) { }
}

export class LoadSubstituteSuccess implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTE_SUCCESS;

  constructor(public payload: DeputyStateModel) { }
}

export class LoadSubstituteFailure implements Action {

  readonly type = DeputyActionTypes.LOAD_SUBSTITUTE_FAILURE;

  constructor() { }
}


export class LoadPossibleDeputies implements Action {

  readonly type = DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES;

  constructor() { }
}

export class LoadPossibleDeputiesSuccess implements Action {

  readonly type = DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES_SUCCESS;

  constructor(public payload: DeputyStateModel) { }
}

export class LoadPossibleDeputiesFailure implements Action {

  readonly type = DeputyActionTypes.LOAD_POSSIBLE_DEPUTIES_FAILURE;

  constructor() { }
}
export class LoadImpersonalizationList implements Action {
  readonly type = DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST;

  constructor(public criteria: any) { }
}
export class LoadImpersonalizationListFailure implements Action {
  readonly type = DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_FAILURE;

  constructor(public payload: any) { }
}
export class LoadImpersonalizationListSuccess implements Action {
  readonly type = DeputyActionTypes.LOAD_IMPERSONALIZATION_LIST_SUCCESS;

  constructor(public payload: any) { }
}

export class LoadUsersList implements Action {
  readonly type = DeputyActionTypes.LOAD_USERS_LIST;

  constructor(public businessEntityId: string, public criteria: any) { }
}
export class LoadUsersListFailure implements Action {
  readonly type = DeputyActionTypes.LOAD_USERS_LIST_FAILURE;

  constructor() { }
}
export class LoadUsersListSuccess implements Action {
  readonly type = DeputyActionTypes.LOAD_USERS_LIST_SUCCESS;

  constructor(public payload: any) { }
}

export class ImpersonalizeUser implements Action {
  readonly type = DeputyActionTypes.IMPERSONALIZE_USER;

  constructor(public username: string, public businessEntityId: string) { }
}
export class ImpersonalizeUserFailure implements Action {
  readonly type = DeputyActionTypes.IMPERSONALIZE_USER_FAILURE;

  constructor() { }
}
export class ImpersonalizeUserSuccess implements Action {
  readonly type = DeputyActionTypes.IMPERSONALIZE_USER_SUCCESS;

  constructor(public payload: any) { }
}

export class Delete implements Action {
  readonly type = DeputyActionTypes.DELETE;

  constructor(public payload: string = null) { }
}

export class DeleteImpersonalizationList implements Action {
  readonly type = DeputyActionTypes.DELETE_IMPERSONALIZATION_LIST;

  constructor(public payload: string = null) { }
}

export class DeleteBusinessEntityUsers implements Action {
  readonly type = DeputyActionTypes.DELETE_BUSINESS_ENTITY_USERS;

  constructor(public payload: string = null) { }
}

export class DeleteActiveDeputy implements Action {
  readonly type = DeputyActionTypes.DELETE_DEPUTY;

  constructor(public payload: string = null) { }
}
export class DeleteActiveImpersonalization implements Action {
  readonly type = DeputyActionTypes.DELETE_IMPERSONALIZATION;

  constructor(public payload: string = null) { }
}

export type DeputyActionsUnion =

  | LoadSubstitute
  | LoadSubstituteSuccess
  | LoadSubstituteFailure

  | LoadSubstitutesPhotos
  | LoadSubstitutesPhotosSuccess
  | LoadSubstitutesPhotosFailure

  | LoadPossibleDeputies
  | LoadPossibleDeputiesSuccess
  | LoadPossibleDeputiesFailure

  | LoadImpersonalizationList
  | LoadImpersonalizationListFailure
  | LoadImpersonalizationListSuccess

  | LoadUsersList
  | LoadUsersListFailure
  | LoadUsersListSuccess

  | ImpersonalizeUser
  | ImpersonalizeUserFailure
  | ImpersonalizeUserSuccess

  | Delete
  | DeleteImpersonalizationList
  | DeleteBusinessEntityUsers
  | DeleteActiveDeputy
  | DeleteActiveImpersonalization
  ;

